var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproachIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_378)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.999935,
    width: 33,
    height: 33,
    fill: "url(#pattern0_67_378)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_67_378",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_67_378",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4709,
    height: 33.4709,
    fill: "white",
    transform: "translate(0.731445 0.320248)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_67_378",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFI0lEQVR4nO2ca6gVRRzAx0fmNbWHRn4pEKxuSRoWgsWFQPEWFEkfk6J3oGURQSZYQk+JoNQKehBFhpRSFgRxPxgRBJUFXelDhKLU7Wml9tbuL6Yz0mE7uzNzz+6Z2dn/7/PunPnP78zuzsx/RilBEARBEARBEAQhGYApwHxgHjAudH0aATAemA0MAquAJ4AhYC8wyn+8IVJKBJgBLAKuBR4CtgHDwB+4M6/MOjUSYBnwJeUwP3Q8tQaYAPxUkgz9+JoSOqZaA/QBR0oSsjd0PEkArC9JyFDoWJIAGAdsKEHIptCxJAPlSFkVOo4UpWzsQshg6BiSA7i5CyGzQ9c/KYDrgb/HKEMPHieEjiEZ6E6GZjh0DMlA9zI0W0PHkQSUI0PzYOhYag/lydBcEzqeJskYBVZaximLQsfUJBkrHAaPM1TTAc4AHgPeBjYDlzrcc2NmUckm46bM/VrKpsx1+1TTobWG8XuHRnwOmFiFjIyU9WaW+EeXP0LSAJcBfxY05mvAsVXIyJR5nGo6wNKcnpFlBzCtm3eGYAFY4ijjKO8Dd5TdMwT1r4wLgUNUh/QMV0wmyEGREQHAAvMlIz0jNMC5wH6REQG0UjN/EBkRAMwFvvOQ8SSwy/MF3syvKWCWWRZdbUbXx1iu7we+8WjcDW1poB+IjOLGvRr4LdNInwGn51w/B/jKQ8ZT7cnNwHTgHekZnRt3RcGAbAQ4M3O9zi7f5yFDz1mNz8lE3N7h+sPADaqJALc5jI5H9OPJXH8asMdDxoudZGS2D1ynl1WBD83156smAtzp0bAjwGLgC497toTI7jA97xLgKuA8VQfMi7tKtuVNrVcc12CHDw09eXmKihXgnoplbAcmBYjr7A4fJu2Tl7mPzmAA91Us463s+kYPY3vWUrelKiaAhyuWMQRMDhjfTkv97lKxADxQsYz3gKmBY7TNAKwLWb/2NeXHPRr2sOMoOioZtRAyhn0UWsaV+oUMvO54j35MnKgiIGohZsD1jIcMnYiwrO3+ScCblns+Ak6oqP59yQgxu1Wf90zP/196DC0peoN9Jz4BTqqgR9/aNhNwAHja9XeiFGJkvOQhQyciXFxQ3kRgbdtg64A5HWFaBXV/NKeOwy7vqOiEmMbT0xWu/KqzQzzKP76q4yiAsyzpP2tqJUSvXZgJOld+AS5SkUDrXJIi3q2NEM+vIkxWyICKCOBeS5131UnICx4yfgYuUJEBrEtCCLDQQ4Y+J2ShihASEuI6jb4/5rUBEhKyxkHG9zpvqkcLQ7eYj4tXzU6mvqYJGbBU4lvgnB7U42QzXsjyKTCzMUJMRfK+sL7WizY9qsMrBQ2xpWlC+sy5H0fT/0fNQtGpPfr96WZiMo+/bCP7pIS0VWiqySSc2ePf7cdOf+OEhILWn8DGXEsZIkSEJArSQ+JKMEOExJVghgiJK8EMERJXghkiJK4EM0RI6UK6GlAhQkRI0iN16SEVEiLBDHlkxZVghgiJK8EMERJXghkiJK4EM0RIXAlmiJC4FnYQISIk2oGh9JD4hNxtqcROhzI+tpSx2nK/PojGxpzY4ygF4ApLJTY7lPGypYzLLfdPNtsb8jhk27seQxyloAMtOH/kiMvB8zobvmAs87nLqQwFg1PNI3WJoxTMV87uDps4nY84MqdJZ0+g3u2a+WgaVJ9vkmWr68kOMcRRdoLCcuB+c+SSd9aivge43ZSxfIwTlQNmT+LasWwKiiUOQRAEQRAEQRAEQRAEQVA14x+TnbyYbPOzdAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproachIcon5);
export default __webpack_public_path__ + "static/media/approach-icon-5.249f550063c3c109b72f45536cfbdd8d.svg";
export { ForwardRef as ReactComponent };